module.exports = __webpack_public_path__ + "static/GrayStarogardGdanski-06e41456b313e11dbe03c8374f8ee425.svg";